import { type ReactNode } from "react";
import { type LucideIcon } from "lucide-react";

import { cn } from "~/lib/utils";

export function IconTextRow({
  icon: Icon,
  children,
  className,
  iconClassName,
  definitionLabel,
}: {
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
  iconClassName?: string;
  definitionLabel?: string;
}) {
  return (
    <div
      className={cn(
        "grid min-w-0 items-start",
        Icon && "grid-cols-[20px_minmax(0,1fr)] gap-x-3",
        className,
      )}
    >
      {Icon && (
        <Icon
          className={cn(
            "text-brand mt-px size-[18px] justify-self-center",
            iconClassName,
          )}
          aria-hidden="true"
        />
      )}
      {definitionLabel ? (
        <>
          <dt className="sr-only">{definitionLabel}</dt>
          <dd className="col-start-2 min-w-0">{children}</dd>
        </>
      ) : (
        <div className="min-w-0">{children}</div>
      )}
    </div>
  );
}
